export enum Jezyk {
    pl,
    en
}